import React from "react";
import useWaveAudio from "@web-src/features/app/hooks/useWaveAudio";
import { useUniqueDOMId } from "@jugl-web/utils";
import { PlainButton } from "@jugl-web/ui-components";
import { useUnmount } from "react-use";
import { ReactComponent as PlayIcon } from "./assets/play.svg";
import { ReactComponent as StopIcon } from "./assets/stop.svg";

export const ChatAudioPlayer: React.FC<{ url: string }> = ({ url }) => {
  const id = useUniqueDOMId();
  const { playing, play, pause, currentTimeStr, durationStr } = useWaveAudio(
    url,
    {
      container: `#${id}`,
      waveColor: "#A4A5AA",
      progressColor: "#1A75D2",
      cursorWidth: 0,
      barWidth: 2,
      barGap: 3,
      barMinHeight: 2,
      barRadius: 2,
      height: 32,
      hideScrollbar: true,
    }
  );
  useUnmount(() => {
    pause();
  });

  return (
    <div className="flex w-full items-center gap-4">
      <PlainButton
        className="bg-grey-200 hover:bg-grey-300 flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-colors"
        onClick={playing ? pause : play}
      >
        {playing ? <StopIcon /> : <PlayIcon />}
      </PlainButton>
      <span className="text-xs leading-[130%] text-[#707577]">
        {playing ? currentTimeStr : durationStr}
      </span>
      <div id={id} className="w-full" />
    </div>
  );
};
